const WISHLIST_KEY = 'shopify_wishlist';

function getWishlist() {
  try {
    const data = JSON.parse(localStorage.getItem(WISHLIST_KEY));
    return Array.isArray(data) ? data : [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(wishlist) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  updateWishlistHeaderCount();
  updateWishlistButtons();
}

function toggleWishlist(handle) {
  if (!handle) return;
  let wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  
  if (index !== -1) {
    wishlist.splice(index, 1);
  } else {
    wishlist.push(handle);
  }
  
  saveWishlist(wishlist);
  document.dispatchEvent(new CustomEvent('wishlist:updated'));
  renderWishlistPage();
}

function updateWishlistButtons() {
  const wishlist = getWishlist();
  document.querySelectorAll('.la-heart[data-handle], .sm-c-heart[data-handle], .wishlist-btn[data-handle]').forEach(btn => {
    const handle = btn.dataset.handle;
    btn.classList.toggle('la-wl', wishlist.includes(handle));
    btn.classList.toggle('active', wishlist.includes(handle));
  });
}

function updateWishlistHeaderCount() {
  const wishlist = getWishlist();
  const count = wishlist.length;
  
  const badges = document.querySelectorAll('.header__icon--wishlist .badge, [data-wishlist-count], .wishlist-count-badge');
  badges.forEach(badge => {
    badge.textContent = count;
    badge.classList.toggle('on', count > 0);
    badge.style.display = count > 0 ? '' : 'none';
  });
}

function formatMoney(cents) {
  return 'R ' + (cents / 100).toFixed(2);
}

async function renderWishlistPage() {
  const container = document.getElementById('wishlist-grid');
  const emptyState = document.getElementById('wishlist-empty');
  const countText = document.getElementById('wishlist-count-text');
  if (!container) return;

  let wishlist = getWishlist();

  if (wishlist.length === 0) {
    container.innerHTML = '';
    if (emptyState) emptyState.style.display = 'block';
    if (countText) countText.innerText = '0 ITEMS SAVED';
    return;
  }

  const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root 
    ? window.Shopify.routes.root 
    : '/';

  try {
    const productResults = await Promise.all(
      wishlist.map(async (handle) => {
        try {
          const res = await fetch(`${rootUrl}products/${handle}.js`);
          if (!res.ok) return { handle, valid: false };
          const data = await res.json();
          return { handle, valid: true, data };
        } catch (err) {
          return { handle, valid: false };
        }
      })
    );

    const validProducts = productResults.filter(item => item.valid).map(item => item.data);
    const validHandles = productResults.filter(item => item.valid).map(item => item.handle);

    if (validHandles.length !== wishlist.length) {
      saveWishlist(validHandles);
      wishlist = validHandles;
    }

    if (validProducts.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.style.display = 'block';
      if (countText) countText.innerText = '0 ITEMS SAVED';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    if (countText) countText.innerText = `${validProducts.length} ITEM${validProducts.length > 1 ? 'S' : ''} SAVED`;

    container.innerHTML = validProducts.map(product => {
      const priceFormatted = formatMoney(product.price);
      const onSale = product.compare_at_price > product.price;
      const compareFormatted = onSale ? formatMoney(product.compare_at_price) : '';
      const saveAmount = onSale ? formatMoney(product.compare_at_price - product.price) : '';
      const pct = onSale ? Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100) : 0;
      const primaryImg = product.featured_image || '';
      const hoverImg = product.images && product.images.length > 1 ? product.images[1] : '';

      const stockHtml = product.available
        ? `<span class="sm-c-stk sm-c-sin"><span class="sm-c-sdot"></span>In Stock</span>`
        : `<span class="sm-c-stk sm-c-sout"><span class="sm-c-sdot"></span>Out of Stock</span>`;

      return `
        <article class="sm-c-card">
          <a href="${product.url}" class="sm-c-card__link" aria-label="${product.title}"></a>

          <div class="sm-c-badges">
            ${onSale ? `<span class="sm-c-badge sm-c-bsale">-${pct}%</span>` : ''}
          </div>

          <button type="button" class="sm-c-heart" onclick="toggleWishlist('${product.handle}')" aria-label="Remove item">
            <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          </button>

          <div class="sm-c-img">
            ${primaryImg ? `<img class="sm-c-img__primary" src="${primaryImg}" alt="${product.title}" loading="lazy">` : ''}
            ${hoverImg ? `<img class="sm-c-img__hover" src="${hoverImg}" alt="${product.title}" loading="lazy">` : ''}
          </div>

          <div class="sm-c-info">
            <div class="sm-c-cat">${product.type || '&nbsp;'}</div>
            <div class="sm-c-name">${product.title}</div>

            <div class="sm-c-stk-wrap">
              ${stockHtml}
            </div>

            <div class="sm-c-prow">
              <span class="sm-c-price">${priceFormatted}</span>
              ${onSale ? `<span class="sm-c-was">${compareFormatted}</span>` : ''}
              ${onSale ? `<span class="sm-c-pill">Save ${saveAmount}</span>` : ''}
            </div>

            <div class="sm-c-btns">
              <a href="${product.url}" class="sm-c-btnmain">View Details</a>
            </div>
          </div>
        </article>
      `;
    }).join('');
  } catch (e) {
    container.innerHTML = '<p style="text-align:center; padding: 2rem;">Error loading wishlist items.</p>';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  updateWishlistButtons();
  updateWishlistHeaderCount();
  renderWishlistPage();
});

document.addEventListener('wishlist:updated', () => {
  updateWishlistButtons();
  updateWishlistHeaderCount();
  renderWishlistPage();
});

window.addEventListener('storage', (e) => {
  if (e.key === WISHLIST_KEY) {
    updateWishlistButtons();
    updateWishlistHeaderCount();
    renderWishlistPage();
  }
});